import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

export const CustomTooltip = props => {
    const {config, children} = props;
    const {text = "tooltip", placement = "top", id = "tooltip"} = config;

    return (
        <OverlayTrigger
            placement={placement}
            delay={{show: 250, hide: 400}}
            overlay={
                <Tooltip id={id} className={`tooltip_${placement}`} {...props}>
                    <span dangerouslySetInnerHTML={{__html: text}} />
                </Tooltip>
            }
        >
            {children}
        </OverlayTrigger>
    );
};
